// extracted by mini-css-extract-plugin
export default {"card":"R3-z"};